import { useParticipantQuery } from './index';

export const useParticipantTimeZone = (email?: string) => {
  const { participant } = useParticipantQuery(email);

  return (
    participant?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
  );
};
